import React, { Component } from 'react';
import { Card, DropdownMenu, ListItem, Switch } from 'react-md';
import ReactEcharts from 'react-echarts-component';

import ChartHelper from '../Helper/ChartHelper';

import ZDropdownMenu from '../Utility/ZDropdownMenu';

import StackupChartMenuItem from './StackupChartMenuItem';
import StackupCardItem from './StackupCardItem';
import StackupSortItem from './StackupSortItem';

export default class StackupViewCentral extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeChart: "bar",
            chartHidden: window.localStorage.stackupChartHidden != undefined ? (window.localStorage.stackupChartHidden === 'true') : false
        }
        this.chartHelper = new ChartHelper();
        this.viewOuter = null;
        this.chartLineCrossed = false;

        // this.calcPercentileFromZscore = this.calcPercentileFromZscore.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.handleChangeChart = this.handleChangeChart.bind(this);
        this.toggleChartHidden = this.toggleChartHidden.bind(this);
        this.generateSortMenuItems = this.generateSortMenuItems.bind(this);
        this.generateChartMenuItems = this.generateChartMenuItems.bind(this);
        this.generateLocationsCard = this.generateLocationsCard.bind(this);
        this.generateStackItems = this.generateStackItems.bind(this);
    }


    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleChangeChart(chartName) {
        this.setState({ activeChart: chartName });
    }

    handleScrollTop(event) {
        $(".stackup-central-outer")[0].scrollTo(0, 0);
    }

    handleScroll(e) {
        var self = this;
        if (this.props.screenContext.hasCharts) {
            let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
            var where = e.target.scrollTop / (12.75 * rem);
            var style = {};
            if (where <= 0) {

                if (this.chartEl.style.transition != 'height 0.25s ease-in-out 0s') {
                    setTimeout(() => {
                        self.chartEl.style.transition = 'height 0.25s ease-in-out 0s';
                    }, 250);
                }

                this.chartEl.classList.remove('stackup-central-chart-card-container--active');
            } else if (where >= 1) {

                this.chartEl.style.transition = 'top 0.25s ease-in-out 0s, left 0.25s ease-in-out 0s,  transform 0.25s ease-in-out 0s';

                this.chartEl.classList.add('stackup-central-chart-card-container--active');
            } else {

                if (this.chartEl.style.transition != 'height 0.25s ease-in-out 0s') {
                    setTimeout(() => {
                        self.chartEl.style.transition = 'height 0.25s ease-in-out 0s';
                    }, 250);
                }

                this.chartEl.classList.remove('stackup-central-chart-card-container--active');
            }
        }

        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    toggleChartHidden() {

        if (this.state.chartHidden) {
            this.chartEl.classList.remove('stackup-chart-hidden');
        } else {
            this.chartEl.classList.add('stackup-chart-hidden');
        }

        window.localStorage.setItem('stackupChartHidden', !this.state.chartHidden);

        this.setState({ chartHidden: !this.state.chartHidden });
    }

    generateSortMenuItems() {
        let sortMenuItems = [];

        sortMenuItems.push((<StackupSortItem onClick={this.props.changeSort} set="NAME" filter={this.props.screenContext} icon="sort_by_alpha" text="Name" add={null} />));
        sortMenuItems.push((<StackupSortItem onClick={this.props.changeSort} set="PERCENTILE" filter={this.props.screenContext} icon="sort" text="Percentile" add={null} />));
        sortMenuItems.push((<StackupSortItem onClick={this.props.changeSort} set="RANK" filter={this.props.screenContext} icon="sort" text="Rank" add={null} />));
        sortMenuItems.push((<StackupSortItem closeMenuOnClick onClick={this.props.toggleSelectKpi} style={{ padding: '0 0.7rem 0 0' }} set="" filter={this.props.screenContext} icon="format_list_bulleted" text="Select KPI" add={null} />));

        return sortMenuItems;
    }

    generateChartMenuItems() {
        let chartMenuItems = [];

        chartMenuItems.push((<StackupChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="bar" icon="equalizer" text="Bar Chart" />));
        chartMenuItems.push((<StackupChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="bell" icon="bell" text="Bell Curve" />));
        chartMenuItems.push((<StackupChartMenuItem closeMenuOnClick onClick={this.toggleChartHidden} icon="swap_vert" text="Collapse Chart" />));

        return chartMenuItems;
    }

    generateLocationsCard() {
        let locationsCard = null;
        let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

        if (this.props.screenContext.mode === 'intro') {

            let locationsPieces = [];

            for (var i = 0; i < this.props.screenContext.locationList.length; i++) {

                let pieceStyle = {};
                pieceStyle.top = '-6rem';

                locationsPieces.push((
                    <div className="stackup-locations-piece" style={pieceStyle}>
                        <div className="stackup-location-icon-container">
                            <div className="material-icons stackup-location-icon">location_on</div>
                        </div>
                        <div className="stackup-location-name-container">
                            <div className="stackup-location-name">
                                {this.props.screenContext.locationList[i].name}
                            </div>
                        </div>
                    </div>
                ));
            }

            locationsCard = <div className="stackup-locations-card">{locationsPieces}</div>

        } else if (this.props.screenContext.mode === 'locs') {

            let locationsPieces = [];

            for (var i = 0; i < this.props.screenContext.locationList.length; i++) {

                let pieceStyle = {};
                pieceStyle.top = (i * rem * 4.6) + rem + 'px';
                pieceStyle.transitionDelay = (this.props.screenContext.locationList.length - (i + 1)) * (1 / this.props.screenContext.locationList.length) + 's';

                locationsPieces.push((
                    <div className="stackup-locations-piece" style={pieceStyle} onClick={this.props.changeTopSelector.bind(null, this.props.screenContext.locationList[i].name).bind(null, i)}>
                        <div className="stackup-location-icon-container">
                            <div className="material-icons stackup-location-icon">location_on</div>
                        </div>
                        <div className="stackup-location-name-container">
                            <div className="stackup-location-name">
                                {this.props.screenContext.locationList[i].name}
                            </div>
                        </div>
                    </div>
                ));
            }

            locationsCard = <div className="stackup-locations-card">{locationsPieces}</div>

        } else if (this.props.screenContext.mode === 'main') {
            let locationsPieces = [];

            for (var i = 0; i < this.props.screenContext.locationList.length; i++) {

                let pieceStyle = {};
                pieceStyle.top = '-6rem';
                let leftDelay = i * (1 / this.props.screenContext.locationList.length) + 's';
                pieceStyle.transition = 'top 0.5s ease-in 1.1s, left 0.35s ease-in-out ' + leftDelay + ', opacity 0.5s ease-in-out ' + leftDelay + ', transform 0.25s ease-in-out';
                pieceStyle.left = this.props.screenContext.locationList[i].locationID != this.props.screenContext.selectedLocation.locationID ? (i % 2 === 0 ? '-100vw' : '100vw') : '';

                if (this.props.screenContext.locationList[i].locationID === this.props.screenContext.selectedLocation.locationID) {
                    pieceStyle.opacity = '0';
                    pieceStyle.transform = 'scale(1.5, 1.5)';
                    pieceStyle.transition = 'top 0.5s ease-in 1.1s, left 0.35s ease-in-out 0s, opacity 0.25s ease-in-out 0s, transform 0.25s ease-in-out 0s';
                }

                locationsPieces.push((
                    <div className="stackup-locations-piece" style={pieceStyle}>
                        <div className="stackup-location-icon-container">
                            <div className="material-icons stackup-location-icon">location_on</div>
                        </div>
                        <div className="stackup-location-name-container">
                            <div className="stackup-location-name">
                                {this.props.screenContext.locationList[i].name}
                            </div>
                        </div>
                    </div>
                ));
            }

            locationsCard = <div className="stackup-locations-card" style={{ pointerEvents: 'none' }}>{locationsPieces}</div>
        }

        return locationsCard;
    }

    generateStackItems() {

        if (this.props.screenContext.mode != 'main') {
            return null;
        }

        let stackItems = [];

        let locationName = this.props.screenContext.selectedLocation.name;
        let kpiList = Object.keys(this.props.stackData[locationName]);
        let period = this.props.screenContext.range === 'CUR' ? 'CYNOW' : 'CY' + this.props.screenContext.range;

        let dataSet = [];
        for (var i = 0; i < kpiList.length; i++) {
            dataSet.push(this.props.stackData[locationName][kpiList[i]][period]);
        }

        if (this.props.screenContext.sortBy === 'NAME') {
            dataSet = _.sortBy(dataSet, 'kpiDesc');
        } else if (this.props.screenContext.sortBy === 'PERCENTILE') {
            dataSet = _.sortBy(dataSet, 'modZScore');
        } else if (this.props.screenContext.sortBy === 'RANK') {
            dataSet = _.sortBy(dataSet, 'rank');
        }

        if (this.props.screenContext.sortByDir === 'DESC') {
            dataSet = dataSet.reverse();
        }

        for (var i = 0; i < dataSet.length; i++) {
            let key = locationName + '|' + dataSet[i].kpiDesc + '|' + period;
            let identity = dataSet[i];

            let active = _.contains(this.props.screenContext.selectedKpiList, identity.kpiDesc);

            stackItems.push((
                <StackupCardItem
                    key={key}
                    identity={identity}
                    active={active}
                    pickMode={this.props.screenContext.selectKpiMode}
                    resetSlider={this.props.screenContext.resetSlider}
                    masterKpiList={this.props.screenContext.masterKpiList}
                    toggleKpi={this.props.toggleKpiListItem}
                />
            ));
        }

        if (this.props.screenContext.resetSlider) {
            let self = this;
            setTimeout(() => {
                if (self.props.screenContext.resetSlider) {
                    self.props.cutResetSlider();
                }
            }, 100);
        }

        return stackItems;
    }


    renderChart(chartTitleText) {

        if (this.props.screenContext.mode === 'intro') {
            return null;
        }
        let chart = null;
        let dropDownJsx = null;
        let range = this.props.screenContext.range;


        if (this.props.screenContext.mode === 'main') {

            let locationName = this.props.screenContext.selectedLocation.name;
            let kpiList = Object.keys(this.props.stackData[locationName]);
            let period = this.props.screenContext.range === 'CUR' ? 'CYNOW' : 'CY' + this.props.screenContext.range;

            let xData = [];
            let yData = [];
            let tempObjs = [];

            for (var i = 0; i < kpiList.length; i++) {
                if (_.contains(this.props.screenContext.selectedKpiList, kpiList[i]) && this.props.stackData[locationName][kpiList[i]][period] != undefined) {

                    tempObjs.push({
                        kpi: kpiList[i],
                        rank: this.props.stackData[locationName][kpiList[i]][period].rank,
                        modZScore: this.props.stackData[locationName][kpiList[i]][period].modZScore,
                        percentile: (this.props.stackData[locationName][kpiList[i]][period].percentile * 100.0).toFixed(1)
                        //percentile: (this.calcPercentileFromZscore(this.props.stackData[locationName][kpiList[i]][period].modZScore).toFixed(4) * 100.0).toFixed(1)
                    });
                }
            }

            if (this.props.screenContext.sortBy === 'NAME') {
                tempObjs = _.sortBy(tempObjs, 'kpi');
            } else if (this.props.screenContext.sortBy === 'PERCENTILE') {
                tempObjs = _.sortBy(tempObjs, 'modZScore');
            } else if (this.props.screenContext.sortBy === 'RANK') {
                tempObjs = _.sortBy(tempObjs, 'rank');
            }
            if (this.props.screenContext.sortByDir === 'DESC') {
                tempObjs = tempObjs.reverse();
            }

            for (var i = 0; i < tempObjs.length; i++) {
                xData.push(tempObjs[i].kpi);
                yData.push(tempObjs[i].percentile);
            }

            if (this.state.activeChart === 'bar') {
                chart = this.chartHelper.generateStackupBarChart(xData, yData);
            } if (this.state.activeChart === 'bell') {
                chart = this.chartHelper.generateStackupBellChart(xData, yData);
            }
        }

        let chartClass = 'stackup-central-chart-card-container';
        let chartStyle = {};
        if (this.props.screenContext.mode === 'locs') {
            chartStyle.opacity = '0';
            chartStyle.transform = 'scale(0.5, 0.5)';
        }
        if (!this.state.chartHidden) {
            dropDownJsx = (
                <ZDropdownMenu
                    id="stackup-central-title-button-container"
                    className="stackup-central-title-button-container"
                    menuItems={this.generateChartMenuItems()}
                    isBlocked={true}
                // anchor={{
                //     x: DropdownMenu.HorizontalAnchors.INNER_RIGHT,
                //     y: DropdownMenu.VerticalAnchors.OVERLAP
                // }}
                // repositionOnScroll={false}
                >
                    <div className="stackup-central-title-button material-icons">more_vert</div>
                </ZDropdownMenu>
            );
        } else {
            chartClass += ' stackup-chart-hidden';
            dropDownJsx = (
                <div className="stackup-central-title-button-container" onClick={this.toggleChartHidden}><div className="stackup-central-title-button material-icons">swap_vert</div></div>
            );
        }

        return (
            <div className={chartClass} style={chartStyle} ref={(el) => { this.chartEl = el; }} onClick={this.handleScrollTop}>
                <div className="stackup-central-title-container">
                    <div className="stackup-central-title">{chartTitleText}</div>
                    {dropDownJsx}
                </div>
                <div className="stackup-central-chart-container">
                    {chart}
                </div>
                <div className="material-icons chart-axis-icon-x">trending_up</div>
                <div className="chart-axis-icon-y">{'%'}</div>
            </div>
        );
    }

    render() {

        if (this.props.stackData === undefined || this.props.stackData.length === 0 || Object.keys(this.props.stackData).length === 0 ||
            this.props.screenContext === undefined || this.props.screenContext.selectedLocation === undefined || this.props.screenContext.locationList.length === 0 ||
            (this.props.screenContext.mode === 'main' && Object.keys(this.props.stackData[this.props.screenContext.selectedLocation.name]).length === 0)) {
            return (
                <div className="stackup-central-outer" ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScroll}>
                    <div className="error-message-outer">
                        <div className="error-image-container">
                            <div className="error-image material-icons">layers</div>
                        </div>
                        <div className="error-message-container">
                            <div className="error-message">{"Stack-Up Data for Selected " + (this.props.tagFilter.tags.length === 0 ? "Date" : "Tags") + " Not Found"}</div>
                        </div>
                    </div>
                </div>
            );
        }

        let titleText = "";
        switch (this.props.screenContext.range) {
            case 'CUR': titleText += 'On This Day';
                break;
            case 'WTD': titleText += 'Week to Date';
                break;
            case 'MTD': titleText += 'Month to Date';
                break;
            case 'QTD': titleText += 'Quarter to Date';
                break;
            case 'YTD': titleText += 'Year to Date';
                break;
        }

        let regTitleText = "Metrics (" + titleText + ")";

        var chart = this.renderChart(titleText);

        let sortMenuItems = this.generateSortMenuItems();

        let topSpacerClass = 'stackup-central-chart-spacer';
        if (this.state.chartHidden) {
            topSpacerClass += ' spacer-hidden';
        }

        let locationsCard = this.generateLocationsCard();


        let mainCardStyle = {}
        if (this.props.screenContext.mode === 'locs' || this.props.screenContext.mode === 'intro') {
            mainCardStyle.opacity = '0';
            mainCardStyle.transform = 'scale(0.5, 0.5)';
        }

        let stackItems = this.generateStackItems();

        let selectKpiStyle = {};
        if (this.props.screenContext.selectKpiMode) {
            selectKpiStyle.pointerEvents = 'auto';
            selectKpiStyle.opacity = '1';
        }

        return (
            <div className="stackup-central-outer" ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScroll}>
                <div className={topSpacerClass}></div>
                {chart}
                <div className="stackup-central-regular-card-container" style={mainCardStyle}>
                    <div className="stackup-central-title-container">
                        <div className="stackup-central-title">{regTitleText}</div>
                        <ZDropdownMenu
                            id="stackup-central-title-button-container"
                            className="stackup-central-title-button-container"
                            menuItems={sortMenuItems}
                            isBlocked={true}
                        // anchor={{
                        //     x: DropdownMenu.HorizontalAnchors.INNER_RIGHT,
                        //     y: DropdownMenu.VerticalAnchors.OVERLAP
                        // }}
                        // repositionOnScroll={false}
                        >
                            <div className="stackup-central-title-button material-icons">more_vert</div>
                        </ZDropdownMenu>
                        <div className="stackup-select-kpi-button" style={selectKpiStyle} onClick={this.props.toggleSelectKpi}>SAVE</div>
                    </div>
                    {stackItems}
                </div>
                {locationsCard}
                <div className="spacer-short"></div>
            </div>
        );
    }
}